/**
 * Split settings components to their own chunk.
 * Additionally to reducing the code for the main bundle, it prevents loading
 * Stripe at app launch and helps reduce our TTI.
 */
import { lazyWithPreload } from '../../navigation';

export const SettingsScreen = lazyWithPreload(() => import('./SettingsScreen'));
export const OrganizationMigrateSettings = lazyWithPreload(
    () => import('./OrganizationSettings/OrganizationMigrateSettings')
);
